import defineService from './defineService'
import {idFromProductUrl} from '@/lib/selectedProduct';
import {CANCELLED, READY_FOR_PRODUCTION} from "@/lib/orderStatus";

const postOrderChange = defineService('post', 'api/v1/cart/orders/:id/change/', {
  suffixFunc({category}) {
    return category ? '-'+category : '';
  }
})
const postAddPayment = defineService(
  'post',
  'api/v1/cart/custom/checkout/add-payment/'
);

const postOrderClone = defineService(
  'post',
  'api/v1/cart/custom/orders/clone'
);

function processError(e) {
    // Unwrap error
    if (e.response && e.response.data) e = e.response.data;
    if (e.non_field_errors) e = e.non_field_errors;
    if (e.reason) e = e.reason;
    if (e.cancellation_reason) {
      // Transform { "cancellation_reason": [ "This field may not be blank." ] }
      e = "Please provide a reason for cancellation";
    }
    if (e.join) e = e.join(' ');
    throw e;
}

export async function approveOrder(order_id) {
  return changeOrder(order_id, {
    change_type: 'change_status',
    new_status: READY_FOR_PRODUCTION
  });
}

export async function cancelOrder(order_id, cancellation_reason) {
  return changeOrder(order_id, {
    change_type: 'change_status',
    new_status: CANCELLED,
    cancellation_reason
  });
}


export async function addLine(order_id, product, boxSize, quantity=1) {
  product = idFromProductUrl(product);
  return changeOrder(order_id, {
    change_type: 'add_line',
    product,
    quantity,
    attributes: [
      {type: 'box_size', value: boxSize}
    ]
  });
}

export async function changeLine(order_id, line, product, boxSize, quantity=1) {
  product = idFromProductUrl(product);
  return changeOrder(order_id, {
    change_type: 'change_line',
    line,
    product,
    quantity,
    attributes: [
      {type: 'box_size', value: boxSize}
    ]
  });
}

export async function deleteLine(order_id, line) {
  return changeOrder(order_id, {
    change_type: 'delete_line',
    line
  });
}

export async function addDiscount(orderId, voucherCode) {
  return changeOrder(orderId, {
    change_type: 'add_discount',
    voucher: voucherCode,
  });
}

export async function changeShippingMethod(orderId, shipping_method) {
  return changeOrder(orderId, {
    change_type: 'change_shipping_method',
    shipping_method,
  });
}

/**
 * Internal method that unwraps the error
 */
function changeOrder(order_id, data) {
  return postOrderChange(order_id, data).catch(processError);
}

export async function addPayment(orderUrl, saved_card) {
  return postAddPayment({order: orderUrl, payment_method: 'SavedCard', stripe_token: saved_card});
}

export async function cloneForResend(data) {
  return postOrderClone(data);
}



// WEBPACK FOOTER //
// ./src/services/approval.js